import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import { FAQLinksMobile } from '../sections/InPageLinksMobile';

import Header from '../sections/Header';
import Benefits from '../sections/Benefits';
import HowItWorks from '../sections/HowItWorks';
import AboutTC from '../sections/AboutTC';
import HowPeopleSpendAndEarn from '../sections/HowPeopleSpendAndEarn';
import WaysEarnSpend from '../sections/WaysEarnSpend';
import MoreAboutTempoAndBenefits from '../sections/MoreAboutTempoAndBenefits';

export const FAQsTemplate = ({
  mainTitle,
  mainSubtitle,
  mainDescription,
  involvedItems,
  earnSectionTitle,
  earnSectionContnet,
  spendSectionTitle,
  spendSectionContnet,
  affectSectionTitle,
  affectSectionContnet,
}) => {
  return (
    <>
      <Header page="FAQs" title="How Tempo Time Credits work" />
      <FAQLinksMobile />
      <AboutTC
        darkBG
        title={mainTitle}
        boldParagraph={mainSubtitle}
        lightParagraph={mainDescription}
      />
      <HowItWorks page="FAQs" />
      <Benefits title="Who can get involved?" items={involvedItems} />
      <HowPeopleSpendAndEarn
        bgcolor="blueGrad"
        earnSectionTitle={earnSectionTitle}
        earnSectionContnet={earnSectionContnet}
      />
      <WaysEarnSpend type="earn" />
      <HowPeopleSpendAndEarn
        bgcolor="pinkGrad"
        isSpend
        spendSectionTitle={spendSectionTitle}
        spendSectionContnet={spendSectionContnet}
      />
      <WaysEarnSpend type="spend" />
      <MoreAboutTempoAndBenefits
        title={affectSectionTitle}
        description={affectSectionContnet}
        bgcolor="gray2"
      />
    </>
  );
};

const FAQsPage = ({
  data: {
    markdownRemark: { frontmatter },
  },
}) => {
  const {
    mainTitle,
    mainSubtitle,
    mainDescription,
    involvedList,
    earnSectionTitle,
    earnSectionContnet,
    spendSectionTitle,
    spendSectionContnet,
    affectSectionTitle,
    affectSectionContnet,
  } = frontmatter;
  const involvedItems = Object.keys(involvedList).map(i => involvedList[i]);
  return (
    <Layout>
      <FAQsTemplate
        mainTitle={mainTitle}
        mainSubtitle={mainSubtitle}
        mainDescription={mainDescription}
        involvedItems={involvedItems}
        earnSectionTitle={earnSectionTitle}
        earnSectionContnet={earnSectionContnet}
        spendSectionTitle={spendSectionTitle}
        spendSectionContnet={spendSectionContnet}
        affectSectionTitle={affectSectionTitle}
        affectSectionContnet={affectSectionContnet}
      />
    </Layout>
  );
};

export const FAQsQuery = graphql`
  query FAQsQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        mainTitle
        mainSubtitle
        mainDescription
        involvedList {
          firstItem {
            title
            description
          }
          secondItem {
            title
            description
          }
          thirdItem {
            title
            description
          }
          fourthItem {
            title
            description
          }
        }
        earnSectionTitle
        earnSectionContnet
        spendSectionTitle
        spendSectionContnet
        affectSectionTitle
        affectSectionContnet
      }
    }
  }
`;

export default FAQsPage;
